import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const customSkillDefinition: FilterDefinition<TreeFilter> = {
  id: FilterId.CUSTOM_SKILL,
  name: 'Skill',
  selectionListIds: ['skill_0', 'skill_1', 'skill_2', 'skill_3'],
  selections: [],
  type: FilterType.TREE,
  isVisible: true,
};

export const customSkillHandler: FilterHandler<TreeFilter> = {
  isActive(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: TreeFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds() {
    return [];
  },
};
